export const CAMPOS_PROGRAMA = {
  ESCUELA: 'escuela',
  ESCUELA_NOMBRE: 'escuela__nombre',
  NIVEL_FORMACION: 'nivel_formacion',
  PERIODOS: 'no_periodos',
  NOMBRE_PROGRAMA_ACADEMICO: 'nombre',
  MODALIDAD: 'modalidad',
  CREDITOS: 'creditos',
  CODIGO_SNIES: 'snies',
  PROGRAMA_ACREDITADO: 'programa_acreditado',
  ACUERDO_CREACION_PROGRAMA: 'acdp',

  RC_FECHA_REGISTRO: 'rc_fecha_creacion',
  RC_FECHA_VENCIMIENTO: 'rc_fecha_vencimiento',
  RC_RESOLUCION: 'rc_resolucion',
  RC_FILES: 'rc_archivo_url',

  AP_FECHA_REGISTRO: 'ac_fecha_inicio',
  AP_FECHA_VENCIMIENTO: 'ac_fecha_vencimiento',
  AP_RESOLUCION: 'ac_resolucion',
  AP_ANIOS: 'ac_años',
  AP_FILES: 'ac_archivo_url'
}

export const LABELS_PROGRAMA = {
  [CAMPOS_PROGRAMA.ESCUELA]: 'Escuela',
  [CAMPOS_PROGRAMA.ESCUELA_NOMBRE]: 'Nombre de la escuela',
  [CAMPOS_PROGRAMA.NIVEL_FORMACION]: 'Nivel de formación',
  [CAMPOS_PROGRAMA.PERIODOS]: 'Periodos',
  [CAMPOS_PROGRAMA.NOMBRE_PROGRAMA_ACADEMICO]: 'Nombre del Programa Académico',
  [CAMPOS_PROGRAMA.MODALIDAD]: 'Modalidad',
  [CAMPOS_PROGRAMA.CREDITOS]: 'Creditos',
  [CAMPOS_PROGRAMA.CODIGO_SNIES]: 'Codigo SNIES',
  [CAMPOS_PROGRAMA.PROGRAMA_ACREDITADO]: 'Programa Acreditado',
  [CAMPOS_PROGRAMA.ACUERDO_CREACION_PROGRAMA]: 'Acuerdo de creación del programa',

  [CAMPOS_PROGRAMA.RC_FECHA_REGISTRO]: 'Fecha de registro',
  [CAMPOS_PROGRAMA.RC_FECHA_VENCIMIENTO]: 'Fecha de vencimiento',
  [CAMPOS_PROGRAMA.RC_RESOLUCION]: 'Resolución',
  [CAMPOS_PROGRAMA.RC_FILES]: 'Documentos',

  [CAMPOS_PROGRAMA.AP_FECHA_REGISTRO]: 'Fecha de acreditacion',
  [CAMPOS_PROGRAMA.AP_FECHA_VENCIMIENTO]: 'Fecha de vencimiento',
  [CAMPOS_PROGRAMA.AP_RESOLUCION]: 'Resolución',
  [CAMPOS_PROGRAMA.AP_ANIOS]: 'Años',
  [CAMPOS_PROGRAMA.AP_FILES]: 'Documentos'
}

export const MAXIMO_NUMERO_DE_PERIODOS = 12
export const LIMITE_CARACTERES_ACDP = 200

export const CARPETA_REGISTRO_CALIFICADO = 'registros-calificados';
export const CARPETA_ACREDITACION_CALIDAD = 'acreditaciones-calidad';